import React from "react";
import "./Logo.css";

const Logo = ({ lang }) => {
  const subtitle = {
    "cs-CZ": "vokálně–instrumentální soubor",
    "en-GB": "vocal-instrumental ensemble",
    "fr-FR": "ensemble musical, vocal et instrumental",
    "de-DE": "Musik-, Vokal- und Instrumentalensemble",
  };
  return (
    <div className="logo">
      <p style={{ color: "rgb(141,109,41)" }}>M</p>
      <p style={{ color: "rgb(162,122,45)" }}>u</p>
      <p style={{ color: "rgb(198,155,65)" }}>s</p>
      <p style={{ color: "rgb(223,181,84)" }}>i</p>
      <p style={{ color: "rgb(245,195,95)" }}>c</p>
      <p style={{ color: "rgb(246,200,100)" }}>a</p>
      <p> </p>
      <p style={{ color: "rgb(200,150,70)" }}>p</p>
      <p style={{ color: "rgb(170,120,50)" }}>r</p>
      <p style={{ color: "rgb(165,118,45)" }}>o</p>
      <p> </p>
      <p style={{ color: "rgb(167,116,44)" }}>S</p>
      <p style={{ color: "rgb(180,125,40)" }}>a</p>
      <p style={{ color: "rgb(200,140,40)" }}>n</p>
      <p style={{ color: "rgb(220,145,40)" }}>c</p>
      <p style={{ color: "rgb(213,143,37)" }}>t</p>
      <p style={{ color: "rgb(195,132,43)" }}>a</p>
      <p> </p>
      <p style={{ color: "rgb(190,124,45)" }}>C</p>
      <p style={{ color: "rgb(160,102,45)" }}>e</p>
      <p style={{ color: "rgb(150,102,55)" }}>c</p>
      <p style={{ color: "rgb(153, 98,39)" }}>i</p>
      <p style={{ color: "rgb(150,100,40)" }}>l</p>
      <p style={{ color: "rgb(150,100,40)" }}>i</p>
      <p style={{ color: "rgb(150,100,40)" }}>a</p>
      <br />
      <div className="logo-small">{subtitle[lang]}</div>
    </div>
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/UI/Logo/Logo.jsx